export default __webpack_public_path__ + "static/media/Cloak of the Faceless Sphinx.f1026d54.jpg";